import createVueComponent from '../createVueComponent';

const FastForward = createVueComponent('FastForwardIcon', [
  ['polygon', { points: '13 19 22 12 13 5 13 19' }],
  ['polygon', { points: '2 19 11 12 2 5 2 19' }],
]);

export default FastForward;
